
import React, { useState, useEffect, useRef } from 'react';
import { Activity, Check } from 'lucide-react';

const FIRST_NAMES = [
  "João", "Lucas", "Carlos", "Mateus", "Gabriel", "Felipe", "Marcos", "André", "Rodrigo", "Rafael", 
  "Vinícius", "Eduardo", "Diego", "Breno", "Gustavo", "Fernando", "Ricardo", "Thiago", "Bruno", "Samuel"
];
const LAST_INITIALS = ["S.", "M.", "A.", "P.", "R.", "G.", "L.", "F.", "T.", "V.", "B.", "C.", "D.", "E.", "K.", "N.", "O.", "H."];
const NICKNAMES = [
  "mestreFifa", "fifaPro", "traderElite", "sniperFifa", "reiDoOver", "greenMachine", "fifaMaster", 
  "lucroCerto", "doubleFifa", "operadorPro", "fifaGuru", "mitoDoFifa", "kingBet", "fifaLytics_user", 
  "goldTrader", "fifaShark", "betMaster", "proPlayer88", "vicioFifa", "esoccer_expert"
];

// Frases confirmadas conforme solicitação
const ACTIONS = [
  "Acabou de acessar o FifaLytics",
  "Confirmou o acesso ao FifaLytics",
  "Fez o cadastro no FifaLytics"
];

const TIMES = ["agora mesmo", "há poucos segundos", "há 1 min", "há 2 min"];

const SalesNotification: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({ name: '', action: '', time: '' });
  const useNicknameRef = useRef(false);

  const showNotification = () => {
    // Alterna dinamicamente entre Nome Real e Apelido
    useNicknameRef.current = Math.random() > 0.4;
    
    let name = '';
    if (useNicknameRef.current) {
      name = NICKNAMES[Math.floor(Math.random() * NICKNAMES.length)];
    } else {
      const first = FIRST_NAMES[Math.floor(Math.random() * FIRST_NAMES.length)];
      const last = LAST_INITIALS[Math.floor(Math.random() * LAST_INITIALS.length)];
      name = `${first} ${last}`;
    }

    // Sorteia uma das 3 frases principais
    const action = ACTIONS[Math.floor(Math.random() * ACTIONS.length)];
    const time = TIMES[Math.floor(Math.random() * TIMES.length)];

    setData({ name, action, time });
    setIsVisible(true);

    // Tempo de exibição: 8 segundos
    setTimeout(() => {
      setIsVisible(false);
    }, 8000);
  };

  useEffect(() => {
    // Delay inicial ao carregar a página
    const initialTimeout = setTimeout(showNotification, 4000);

    // Ciclo de repetição irregular (8 a 20 segundos) para parecer orgânico
    const interval = setInterval(() => {
      if (!isVisible) {
        showNotification();
      }
    }, Math.random() * (20000 - 8000) + 8000);

    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);

  return (
    <div 
      className={`fixed bottom-6 left-6 z-[200] flex items-center gap-4 bg-white p-4 pr-10 rounded-[28px] shadow-[0_20px_60px_rgba(0,0,0,0.3)] border border-white/50 transition-all duration-700 ease-[cubic-bezier(0.34,1.56,0.64,1)] ${
        isVisible ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-24 opacity-0 scale-90 pointer-events-none'
      }`}
    >
      {/* Ícone de Atividade com Check de Verificado */}
      <div className="relative shrink-0">
        <div className="w-12 h-12 rounded-full bg-[#00ff66] flex items-center justify-center shadow-[0_5px_15px_rgba(0,255,102,0.3)]">
          <Activity size={22} className="text-[#0b0e11]" strokeWidth={3} />
        </div>
        <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-white rounded-full flex items-center justify-center shadow-md">
          <div className="w-5 h-5 bg-[#00ff66] rounded-full flex items-center justify-center">
            <Check size={11} className="text-white" strokeWidth={5} />
          </div>
        </div>
      </div>

      {/* Conteúdo de Texto */}
      <div className="flex flex-col min-w-[190px]">
        <div className="flex items-center gap-2">
          <span className="text-[#0b0e11] font-black text-sm tracking-tight">{data.name}</span>
          <span className="bg-[#f0f2f5] text-[#848e9c] text-[8px] font-black uppercase px-2 py-0.5 rounded-md tracking-wider">
            {data.time}
          </span>
        </div>
        <p className="text-[#474d57] text-[13px] font-bold mt-0.5 leading-tight">
          {data.action}
        </p>
      </div>
    </div>
  );
};

export default SalesNotification;
